import React from 'react';
import { Container, Alert } from 'reactstrap';
import { Helmet } from 'react-helmet';
import ConfirmModal from '@components/ConfirmModal/ConfirmModal';
import { withRouter } from 'react-router';

// Form
import EvidenceOfInsuranceForm from './EvidenceOfInsuranceForm/EvidenceOfInsuranceForm';
import axiosInstance from '@src/axios-instance';
//import { Link } from 'react-router-dom';
import SendModal from './SendModal/SendModal';
import FaxModal from './FaxModal/FaxModal';
import ScheduleModal from './ScheduleModal/ScheduleModal';
import EditScheduleModal from './EditScheduleModal/EditScheduleModal';
import ProgressBox from '@components/ProgressBox/ProgressBox';

import Workflow from '../Workflow/Workflow';
import Header from './Header/Header';

class EvidenceOfInsuranceEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      loading: true,
      sendModal: false,
      scheduleModal: false,
      successSend: false
    };
    this.getEntity();
  }

  getEntity = () => {
    this.setState({ loading: true });
    axiosInstance()
      .get(`/evidence-of-insurances/${this.props.id}.json`)
      .then(response => {
        this.setState({
          loaded: true,
          entity: response.data,
          sendModal: false,
          confirmModalActive: false,
          loading: false
        });
      })
      .catch(err => {
        this.props.history.push(`/eois`);
      });
  };

  successSend = message => {
    this.setState({
      successSend: message
    });
  };

  getQBToken = () => {
    localStorage.setItem('qbRedirect', window.location.pathname);
    axiosInstance()
      .get('/tenants/get-qbtoken-url.json')
      .then(response => {
        window.location.href = response.data;
      });
  };

  toggleModal = modalType => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType]
    }));
  };

  saveEntity = (putData, callback) => {
    this.setState({ loading: true });
    axiosInstance()
      .put(`/evidence-of-insurances/${this.props.id}.json`, putData)
      .then(response => {
        this.setState({ loading: false, entity: response.data });
        callback();
        this.setState({ loading: false });
      })
      .catch(err => {});
  };

  onUpdateUnit = (postData, unitId, callback) => {
    this.setState({ loading: true });
    axiosInstance()
      .put(`/units/${unitId}.json`, postData)
      .then(response => {
        this.getEntity();
        if (callback !== undefined) {
          callback();
        }
        this.setState({ loading: false });
      })
      .catch(err => {
        console.log(err);
      });
  };

  createInvoice = callback => {
    this.setState({
      loading: true
    });
    axiosInstance()
      .post(`/invoices.json`, { entity_id: this.state.entity.id })
      .then(response => {
        this.setState({
          loading: false
        });
        this.getEntity();
        if (callback !== undefined) {
          callback();
        }
      })
      .catch(err => {
        alert(err.response.data.message);
        this.setState({
          loading: false
        });
      });
  };

  deleteEntity = () => {
    this.setState({ loading: true });
    axiosInstance()
      .delete(`/evidence-of-insurances/${this.state.entity.id}.json`)
      .then(response => {
        this.setState({ loading: false });
        if (response.data.result === true) {
          this.props.history.push(`/eois`);
        }
      })
      .catch(err => {
        this.setState({ loading: false });
        alert('Unable to delete EOI. Please try again later.');
      });
  };

  downloadPDF = (response, name) => {
    const byteCharacters = window.atob(response);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  getInvoicePDF = () => {
    axiosInstance()
      .get(`/invoices/${this.state.entity.id}.json`)
      .then(response => {
        this.downloadPDF(response.data.response, 'invoice.pdf');
      })
      .catch(err => {});
  };

  setVerifyStatus = approved => {
    this.setState({ loading: true });
    axiosInstance()
      .post(`/evidence-of-insurances/verify/${this.state.entity.id}.json`, {
        approved: approved
      })
      .then(response => {
        this.setState({
          loading: false,
          entity: response.data,
          approveModal: false,
          denyModal: false,
          pendingModal: false,
          onHoldModal: false,
          reinstateModal: false
        });
      })
      .catch(err => {});
  };

  setSubStatus = (value, field) => {
    this.setState({ loading: true });
    axiosInstance()
      .post(
        `/evidence-of-insurances/set-sub-status/${this.state.entity.id}.json`,
        {
          value: value ? 1 : 0,
          field: field
        }
      )
      .then(response => {
        this.setState({
          loading: false,
          entity: response.data,
          approveModal: false,
          denyModal: false,
          pendingModal: false,
          onHoldModal: false,
          reinstateModal: false
        });
      })
      .catch(err => {});
  };

  sendQBInvoiceRequest = () => {
    this.setState({ loading: true });
    const entity = JSON.parse(JSON.stringify(this.state.entity));
    axiosInstance()
      .get(
        `/evidence-of-insurances/send-qb-invoice/${this.state.entity.id}.json`
      )
      .then(response => {
        entity.qb_invoice_sent = true;
        this.setState({
          loading: false,
          entity: entity,
          sendQBInvoiceModal: false
        });
      })
      .catch(err => {
        this.setState({ loading: false });
      });
  };

  sendQBInvoice = () => {
    this.setState({
      sendQBInvoiceModal: true
    });
  };

  onPreviewClick = () => {
    window.open(
      axiosInstance().defaults.baseURL +
        `evidence-of-insurances/preview/${this.props.id}.json`,
      '_blank'
    );
    return true;
    /*this.setState({
      loading: true
    });
    console.log(axiosInstance().defaults.baseURL);
    axiosInstance()
      .get(`/evidence-of-insurances/preview/${this.props.id}.json`)
      .then(response => {
        this.downloadPDF(response.data.response, response.data.name);
        this.setState({
          loading: false
        });
      })
      .catch(err => {
        console.log(err);
      });*/
  };

  sendFax = postData => {
    this.setState({ loading: true });
    axiosInstance()
      .post(`/evidence-of-insurances/fax/${this.props.id}.json`, postData)
      .then(response => {
        this.setState({
          entity: response.data,
          faxModal: false,
          loading: false
        });
      })
      .catch(err => {
        this.setState({ loading: false });
      });
  };

  render = () => {
    const { entity } = this.state;
    if (entity === undefined) {
      return <Container></Container>;
    }
    return (
      <Container>
        <Helmet>
          <title>NXT Insurance Hub | EOIs</title>
        </Helmet>
        <div>
          {this.state.loading && (
            <ProgressBox
              text={'Loading ...'}
              loader={'transparent-background'}
            />
          )}
          {this.state.loaded && (
            <div>
              <Header
                entity={entity}
                onPreviewClick={this.onPreviewClick}
                toggleModal={this.toggleModal}
                createInvoice={() =>
                  this.setState({ confirmModalActive: true })
                }
                sendQBInvoice={this.sendQBInvoice}
              />

              <div className={'pt-2'}>
                <Workflow chargeable={entity.chargeable} entity={entity} />
              </div>
              {this.state.successSend !== false && (
                <Alert color={'success'} className={'mt-3'}>
                  {this.state.successSend}
                </Alert>
              )}
              {entity.qb_token_failed && (
                <Alert color={'warning'} className={'mt-3'}>
                  The QuickBooks Online token has expired. Please Click on this
                  link{' '}
                  <span onClick={this.getQBToken} className={'pointer'}>
                    <strong>here</strong>
                  </span>{' '}
                  to renew your QuickBooks Online Token now.
                </Alert>
              )}

              <EvidenceOfInsuranceForm
                entity={entity}
                saveEntity={this.saveEntity}
                loading={this.state.loading}
                setLoader={loading => this.setState({ loading: loading })}
                onUpdateUnit={this.onUpdateUnit}
                createInvoice={this.createInvoice}
                getInvoicePdf={this.getInvoicePDF}
                sendQBInvoice={this.sendQBInvoice}
                getEntity={this.getEntity}
              />

              {this.state.sendModal && (
                <React.Fragment>
                  {entity.scheduled_email === null ? (
                    <SendModal
                      isActive={this.state.sendModal}
                      toggle={() => this.toggleModal('sendModal')}
                      entity={this.state.entity}
                      getEntity={this.getEntity}
                      onSuccess={message => this.successSend(message)}
                      loading={loading => this.setState({ loading: loading })}
                      onScheduleClick={() => {
                        this.toggleModal('sendModal');
                        this.toggleModal('scheduleModal');
                      }}
                    />
                  ) : (
                    <EditScheduleModal
                      isActive={this.state.sendModal}
                      toggle={() => this.toggleModal('sendModal')}
                      entity={this.state.entity}
                      getEntity={this.getEntity}
                      onSuccess={message => this.successSend(message)}
                      loading={loading => this.setState({ loading: loading })}
                      onScheduleClick={() => {
                        this.toggleModal('sendModal');
                        this.toggleModal('scheduleModal');
                      }}
                    />
                  )}
                </React.Fragment>
              )}
              {this.state.scheduleModal && (
                <ScheduleModal
                  isActive={this.state.scheduleModal}
                  toggle={() => this.toggleModal('scheduleModal')}
                  entity={this.state.entity}
                  getEntity={this.getEntity}
                  onSuccess={message => this.successSend(message)}
                  loading={loading => this.setState({ loading: loading })}
                  onBackClick={() => {
                    this.toggleModal('scheduleModal');
                    this.toggleModal('sendModal');
                  }}
                />
              )}
              {this.state.approveModal && (
                <ConfirmModal
                  isActive={this.state.approveModal}
                  toggle={() => this.toggleModal('approveModal')}
                  title={'Confirm'}
                  body={
                    'Please confirm before approving this Evidence of Insurance.'
                  }
                  confirmLabel={'Approve'}
                  confirmColor={'warning'}
                  confirmAction={() => this.setVerifyStatus(1)}
                />
              )}
              {this.state.denyModal && (
                <ConfirmModal
                  isActive={this.state.denyModal}
                  toggle={() => this.toggleModal('denyModal')}
                  title={'Confirm'}
                  body={
                    'Please confirm before denying this Evidence of Insurance.'
                  }
                  confirmLabel={'Deny'}
                  confirmAction={() => this.setVerifyStatus(-1)}
                />
              )}
              {this.state.pendingModal && (
                <ConfirmModal
                  isActive={this.state.pendingModal}
                  toggle={() => this.toggleModal('pendingModal')}
                  title={'Confirm'}
                  body={
                    this.state.entity.pending === 0
                      ? 'Please confirm before marking this Evidence of Insurance as Pending.'
                      : 'Please confirm before unmarking this Evidence of Insurance as Pending.'
                  }
                  confirmLabel={'Confirm'}
                  confirmAction={() =>
                    this.setSubStatus(!this.state.entity.pending, 'pending')
                  }
                />
              )}
              {this.state.onHoldModal && (
                <ConfirmModal
                  isActive={this.state.onHoldModal}
                  toggle={() => this.toggleModal('onHoldModal')}
                  title={'Confirm'}
                  body={
                    this.state.entity.on_hold_internal === 0
                      ? 'Please confirm before marking this Evidence of Insurance as On Hold - Internal.'
                      : 'Please confirm before unmarking this Evidence of Insurance as On Hold - Internal.'
                  }
                  confirmLabel={'Confirm'}
                  confirmAction={() =>
                    this.setSubStatus(
                      !this.state.entity.on_hold_internal,
                      'on_hold_internal'
                    )
                  }
                />
              )}
              {this.state.reinstateModal && (
                <ConfirmModal
                  isActive={this.state.reinstateModal}
                  toggle={() => this.toggleModal('reinstateModal')}
                  title={'Confirm'}
                  body={
                    'Please confirm before reinstating this Evidence of Insurance.'
                  }
                  confirmLabel={'Reinstate'}
                  confirmAction={() => this.setVerifyStatus(0)}
                />
              )}
              {this.state.faxModal && (
                <FaxModal
                  isActive={this.state.faxModal}
                  toggle={() => this.toggleModal('faxModal')}
                  entity={this.state.entity}
                  onSubmit={postData => this.sendFax(postData)}
                  loading={loading => this.setState({ loading: loading })}
                />
              )}
              {this.state.confirmModal && (
                <ConfirmModal
                  isActive={this.state.confirmModal}
                  toggle={() => this.toggleModal('confirmModal')}
                  title={'Delete Evidence of Insurance'}
                  body={
                    'Confirm before permanently deleting this evidence of insurance.' +
                    (entity.qb_invoice_id !== null
                      ? ' Invoice for this Evidence of Insurance will also be deleted.'
                      : '')
                  }
                  confirmLabel={'Confirm, delete records'}
                  confirmAction={this.deleteEntity}
                />
              )}
            </div>
          )}
        </div>

        <ConfirmModal
          isActive={this.state.deliveredModal}
          toggle={() => this.setState({ deliveredModal: false })}
          title={'Confirmation'}
          body={
            'Please confirm before marking this Evidence of Insurance [Master Certificate Only] as delivered. No delivery email will be triggered from this system. This action cannot be reversed.'
          }
          confirmLabel={'Yes, Mark As Delivered'}
          confirmAction={() =>
            this.saveEntity({ status: 1 }, () =>
              this.toggleModal('deliveredModal')
            )
          }
        />

        <ConfirmModal
          isActive={this.state.confirmModalActive}
          toggle={() => this.setState({ confirmModalActive: false })}
          title={'Confirmation'}
          body={
            'Would you like to create an invoice on QuickBooks online for this EOI Request?'
          }
          confirmLabel={'Yes, Create the Invoice'}
          confirmAction={() =>
            this.createInvoice(() =>
              this.setState({ confirmModalActive: false })
            )
          }
        />
        <ConfirmModal
          isActive={this.state.sendQBInvoiceModal}
          toggle={() => this.setState({ sendQBInvoiceModal: false })}
          title={'Confirmation'}
          body={'Would you like to email this QuickBooks invoice?'}
          confirmLabel={'Yes, Email the Invoice'}
          confirmAction={this.sendQBInvoiceRequest}
        />
      </Container>
    );
  };
}

export default withRouter(EvidenceOfInsuranceEdit);
